import { createListenerMiddleware, isAnyOf } from "@reduxjs/toolkit";
import { addToCart, removeFromCart, updateQuantity } from "./features/cartSlice";
import { cartLines, trackEvent } from "../analytics";

// Зміни кошика → AddToCart / RemoveFromCart з різницею кількості, і CartValueUpdated з новою сумою
export const analyticsListener = createListenerMiddleware();

analyticsListener.startListening({
  matcher: isAnyOf(addToCart, removeFromCart, updateQuantity),
  effect: (action, listenerApi) => {
    const id = action.payload.id;
    const quantityIn = (state) => state.cart.items.find((i) => i.id === id)?.quantity || 0;
    const delta = quantityIn(listenerApi.getState()) - quantityIn(listenerApi.getOriginalState());
    if (!delta) return;

    const cart = cartLines(listenerApi.getState().cart.items);
    trackEvent(delta > 0 ? "AddToCart" : "RemoveFromCart", {
      product_id: id,
      quantity: Math.abs(delta),
      cart,
    });
    trackEvent("CartValueUpdated", { cart });
  },
});
